<template>
  <v-container fill-height>
    <v-row>
      <v-col md="6" offset-md="3">
        <v-form ref="form" v-model="valid">
          <v-card>

            <v-toolbar dark color="indigo">
              <v-toolbar-title>Добавить новый слайд</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-icon>mdi-plus-circle-outline</v-icon>
            </v-toolbar>
          
            <v-card-text>

              <v-select v-model="room" style="display: none;"
                        :items="rooms" 
                        item-text="text"
                        item-value="value"
                        label="Комната" 
                        prepend-icon="mdi-home"
                        :rules="[v => !!v || 'обязательное поле']">
              </v-select>

              <v-file-input v-model="image" 
                            label="Изображение" 
                            accept="image/*" 
                            :rules="[v => !!v || 'обязательное поле']">
              </v-file-input>


            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="success" :disabled="!valid" @click="onCreateSlide">Добавить слайд</v-btn>
            </v-card-actions>

          </v-card>
        </v-form>

        <v-overlay :value="loadingStatus">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-snackbar v-model="snackbar">
          Новое изображение для слайдера добавлено!
        </v-snackbar>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  
  export default {
    data: () => ({
      room: 'room1',
      image: null,
      rooms: [
        { text: 'Первая комната', value: 'room1' },
        { text: 'Вторая комната', value: 'room2' },
        { text: 'Третья комната (большая)', value: 'room3' }
      ],
      valid: true,
      snackbar: false,
      snackbarStatus: false
    }),
    methods: {
      onCreateSlide(){
        const newSlide = {
            room: this.room,
            image: this.image,
        };
        this.$store.dispatch('createSlide', newSlide);
        this.$refs.form.reset();
        //this.$router.push('/meetups')
        this.snackbarStatus = true;
      }
    },
    computed: {
      loadingStatus(){
        return this.$store.state.loading;
      }
    },
    watch: {
      loadingStatus: function(){
        if(!this.loadingStatus && this.snackbarStatus){
          this.snackbar = true
        }
      }
    }
  }

</script>
